// This file is auto-generated by @hey-api/openapi-ts

export const CustomerProfileTypesEnum = { IMPERSONAL: 'IMPERSONAL', PERSONAL: 'PERSONAL' } as const;

export type CustomerProfileTypesEnum = typeof CustomerProfileTypesEnum[keyof typeof CustomerProfileTypesEnum];
